import InlineVisualEditor from './InlineVisualEditor.tsx';
import NoConfigPlaceholder from './NoConfigPlaceholder.tsx';
import { isValidConfig } from './types.ts';

interface OutputMapperPanelProps {
    config: any;
    onConfigChange: (config: any) => void;
    /** Target field to select when the editor opens. */
    initialTarget?: string | null;
}

const OutputMapperPanel = ({ config, onConfigChange, initialTarget }: OutputMapperPanelProps) => {
    const hasConfig = isValidConfig(config);

    return (
        <div className="flex flex-col flex-1 h-full">
            {hasConfig ? (
                <div className="flex-1 min-h-0 flex flex-col">
                    <div className="flex-1 min-h-0 overflow-hidden">
                        <InlineVisualEditor config={config} onChange={onConfigChange} initialTarget={initialTarget} />
                    </div>
                </div>
            ) : (
                <NoConfigPlaceholder />
            )}
        </div>
    );
};

export default OutputMapperPanel;
